/**
 * s3KeyUtils — client mirror of server/utilities/s3KeyUtils.js.
 * ===========================================================================
 * One place to (a) reduce any S3 reference to a bare object key, and (b) build
 * unsigned asset URLs from a base that is ALWAYS https — so a mis-set
 * REACT_APP_AWS_AI_BUCKET (e.g. `s3://aai-api/`) can never make the client emit
 * an `s3://`-prefixed URL that then gets persisted to the DB as an asset URL.
 * That env vector was the most plausible origin of the historical `s3://…`-as-key
 * junk found in the bucket.
 */
import { config } from '../constants/config';

/** Reduce https://…amazonaws.com/key, s3://bucket/key, or /key to a bare key. */
export const normalizeS3Key = (value) => {
  if (!value || typeof value !== 'string') return value;
  const v = value.trim();
  if (!/^(s3|https?):\/\//i.test(v)) return v.replace(/^\/+/, '');
  try {
    const u = new URL(v);
    return decodeURIComponent(u.pathname).replace(/^\/+/, '');
  } catch (_) {
    return v.replace(/^\/+/, '');
  }
};

/** Always-https asset base (trailing slash) for building unsigned S3 URLs. */
export const s3HttpsBase = () => {
  let base = (config.AWS_AI_BUCKET || '').trim();
  const m = base.match(/^s3:\/\/([^/]+)\/?$/i); // coerce s3://bucket/ -> virtual-hosted https
  if (m) base = `https://${m[1]}.s3.${config.AWS_REGION || 'us-west-1'}.amazonaws.com/`;
  return base.endsWith('/') ? base : `${base}/`;
};
